import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ServicesHeroBanner from "../components/ServicesHeroBanner";
import MultpleCard from "../components/Multple-card";
import ServicesProcess from "../components/ServicesProcess";
import Choose from "../components/Choose";
import ContactForm from "../components/contact-form";
import Blog from "../components/Blog";

import servicesHeaderImage from "../images/comp/services-header-image.webp";
import ChooseuiuxImage from "../images/comp/choose_uiux_img.webp";
import researchIcon from "../images/research-icon.png";
import planningIcon from "../images/Planning.png";
import designIcon from "../images/Design.png";
import qualityIcon from "../images/Quality.png";
import developmentIcon from "../images/development.png";
import ux_icon from "../images/ux_icon.png";
import testingIcon from "../images/Testing.png";
import supportIcon from "../images/Support.png";
import launchIcon from "../images/Deployment & Launch.png";

const UiuxPage = () => {
  const heroBannerData = {
    subtitle: "UI/UX Design",
    title: "Ui That Engages.UI That Delivers",
    description:
      "At Hope Websolution, we believe great design isn’t just about how things look — it’s about how they work. Our UI/UX design services are crafted to deliver seamless, engaging, and user-friendly experiences that elevate your digital presence and help you achieve your business goals.",
    buttonText: "Contact now",
    buttonLink: "/contact",
    img: servicesHeaderImage,
  };
  const cardsData = [
    {
      title: "Research & Discovery",
      description:
        "We begin by understanding your business goals, user needs, and market trends.",
      icon: researchIcon,
    },
    {
      title: "Planning & Strategy",
      description:
        "Our team outlines the project roadmap, defines technology stacks, and creates a clear execution plan tailored to your business objectives.",
      icon: planningIcon,
    },
    {
      title: "Design & Prototyping",
      description:
        "We create intuitive UI/UX designs and interactive prototypes that focus on usability, aesthetics, and user engagement.",
      icon: ux_icon,
    },
    {
      title: "Development",
      description:
        "Our development team brings your designs to life using the latest technologies and best practices, ensuring smooth performance and seamless user experiences.",
      icon: developmentIcon,
    },
    {
      title: "Quality Assurance",
      description:
        "We perform rigorous testing to ensure your UI/UX is bug-free, responsive, and optimized for performance and accessibility.",
      icon: qualityIcon,
    },

    {
      title: "Testing & Launch",
      description:
        "We conduct thorough testing to ensure your UI/UX is bug-free, responsive, and optimized for performance and accessibility.",
      icon: testingIcon,
    },
    {
      title: "Deployment & Launch",
      description:
        "We deploy the final product on your preferred platform with full support, ensuring a smooth and successful launch.",
      icon: launchIcon,
    },
    {
      title: "Ongoing Support",
      description:
        "Post-launch, we provide ongoing updates, performance monitoring, and technical support to keep your system running optimally.",
      icon: supportIcon,
    },
  ];

  const processData = [
    {
      title: "Requirement Analysis",
      description:
        "Understanding your business needs, target audience, and goals to define the website’s scope.",
      icon: researchIcon,
    },
    {
      title: "Wireframing & Planning",
      description:
        "Laying out the website structure, sitemap, and user flow for a clear development path.",
      icon: designIcon,
    },
    {
      title: "Design & Prototyping",
      description:
        "We create intuitive UI/UX designs and interactive prototypes that focus on usability, aesthetics, and user engagement.",
      icon: ux_icon,
    },
    {
      title: "Development",
      description:
        "Our developers build scalable, secure, and high-performing solutions using the latest technologies and coding standards.",
      icon: developmentIcon,
    },
    {
      title: "Quality Assurance",
      description:
        "Our developers build scalable, secure, and high-performing solutions using the latest technologies and coding standards.",
      icon: qualityIcon,
    },
    {
      title: "Testing & QA",
      description:
        "Rigorous testing is conducted to ensure functionality, performance, and security—fixing bugs before deployment.",
      icon: testingIcon,
    },
    {
      title: "Deployment & Launch",
      description:
        "We deploy the final product on your preferred platform with full support, ensuring a smooth and successful launch.",
      icon: launchIcon,
    },
    {
      title: "Maintenance & Support",
      description:
        "Post-launch, we provide ongoing updates, performance monitoring, and technical support to keep your system running optimally.",
      icon: supportIcon,
    },
  ];

  const chooseData = {
    title: "Why Choose Hope Websolution?",
    image: ChooseuiuxImage,
    imageAlt: "Ui/Ux",
    items: [
      {
        label: "Plannings",
        text: "Hope Web Solutions is a leading Web and Mobile App Development company, delivering cutting-edge digital solutions.",
      },
      {
        label: "Our Mission",
        text: "Our mission is to empower businesses with exceptional digital solutions that drive growth, enhance user experience.",
      },
      {
        label: "Our Vision",
        text: "Our vision is to be a global leader in web and mobile app development, recognized for our innovation, quality, and customer satisfaction.",
      },
    ],
    buttonText: "Contact now",
    buttonLink: "/contact",
  };
  return (
    <div>
      <Header />
      <ServicesHeroBanner {...heroBannerData} />
      <section className="planning-section-services">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-8 mb-4 mb-lg-0 position-relative text-center">
              <h2 className="title">Mobile App Development Services</h2>
              <p className="sub-title text-black pt-2">
                At Hope Web Solutions, we provide end-to-end mobile app
                development services designed to deliver impactful and
                user-centric digital products. From strategy and design to
                development and deployment, we help you bring your mobile vision
                to life.
              </p>
            </div>
          </div>
          <div className="process-grid mt-3">
            {/* 👉 Cards Loop */}
            {cardsData.map((item, index) => (
              <MultpleCard
                key={index}
                title={item.title}
                description={item.description}
                icon={item.icon}
              />
            ))}
          </div>
        </div>
      </section>
      <ServicesProcess
        title="UI/UX Desing Process"
        subtitle="At Hope Web Solutions, we follow a smart, data-driven approach powered by AI to deliver tailored solutions. Our process focuses on innovation, efficiency, and scalable growth to help your business succeed with the latest technology."
        processData={processData}
      />
      <Choose {...chooseData} />
      <ContactForm />
      <Blog />
      <Footer />
    </div>
  );
};

export default UiuxPage;
